import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Lender.ImportExcel.IRequest;
type Response = Api.Core.Lender.ImportExcel.IResponse;
type Headers = Api.Core.Lender.ImportExcel.IHeaders;
const url = '/api/Sales/Lender/ImportFromExcel';
export default async function lenderImportExcelApi(request: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    body: request,
    method: HttpMethod.post,
    url: createPathFromRoute(url),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
